'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Placement = require('./utils/Placement');

var _Use = require('./utils/Use');

var _PlacementConstants = require('./PlacementConstants');

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _Styles = require('../utils/Styles');

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var mediumArrowSize = 16;
var smallArrowSize = 12;

var isShepherdArrowWhite = function isShepherdArrowWhite(placement) {
  return (0, _Placement.getSide)(placement) !== 'bottom' && (0, _Placement.getEdge)(placement) !== 'bottom';
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
      placement = _ref.placement,
      popoverUse = _ref.popoverUse;

  if (color) {
    return color;
  }

  if (popoverUse === 'shepherd') {
    return isShepherdArrowWhite(placement) ? _colors.OLAF : _colors.THUNDERDOME;
  }
  return 'inherit';
};

var getSideStyles = function getSideStyles(_ref2) {
  var placement = _ref2.placement,
      width = _ref2.width;

  switch ((0, _Placement.getSide)(placement)) {
    case 'top':
      // Arrow points down
      return (0, _styledComponents.css)(['transform:rotate(45deg);top:calc(100% - ', 'px);'], width / 2);
    case 'right':
      // Arrow points left
      return (0, _styledComponents.css)(['transform:rotate(135deg);left:-', 'px;'], width / 2);
    case 'bottom':
      // Arrow points up
      return (0, _styledComponents.css)(['transform:rotate(-135deg);top:-', 'px;'], width / 2);
    case 'left':
      // Arrow points right
      return (0, _styledComponents.css)(['transform:rotate(-45deg);left:calc(100% - ', 'px);'], width / 2);
    default:
      return '';
  }
};

var getEdgeStyles = function getEdgeStyles(_ref3) {
  var inset = _ref3.inset,
      placement = _ref3.placement,
      width = _ref3.width;

  // Magic calculation, haven't quite figured this out yet
  var adjustedInset = inset + 3;

  switch ((0, _Placement.getEdge)(placement)) {
    case 'top':
      // Arrow is near the bottom of the left or right side
      return (0, _styledComponents.css)(['bottom:', 'px;'], adjustedInset);
    case 'middle':
      return (0, _styledComponents.css)(['top:calc(50% - ', 'px);'], width / 2);
    case 'bottom':
      // Arrow is near the top of the left or right side
      return (0, _styledComponents.css)(['top:', 'px;'], adjustedInset);
    case 'left':
      // Arrow is near the right of the top or bottom side
      return (0, _styledComponents.css)(['right:', 'px;'], adjustedInset);
    case 'center':
      return (0, _styledComponents.css)(['left:calc(50% - ', 'px);'], width / 2);
    case 'right':
      // Arrow is near the left of the top or bottom side
      return (0, _styledComponents.css)(['left:', 'px;'], adjustedInset);

    default:
      return '';
  }
};

var getBorderUseStyles = function getBorderUseStyles(_ref4) {
  var placement = _ref4.placement,
      popoverUse = _ref4.popoverUse;

  if (popoverUse === 'default' || popoverUse === 'longform' || popoverUse === 'shepherd' && isShepherdArrowWhite(placement)) {
    return '1px solid ' + _colors.BATTLESHIP;
  }
  return null;
};

var Arrow = _styledComponents2.default.div.withConfig({
  displayName: 'UIPopoverArrow__Arrow'
})(['position:absolute;pointer-events:none;border:', ';clip-path:polygon(100% 100%,0 100%,100% 0);border-top-left-radius:100%;border-top-color:transparent !important;border-left-color:transparent !important;border-bottom-right-radius:', ';width:', ';height:', ';background-color:', ';', ';', ';.tether-pinned &{display:none;}'], getBorderUseStyles, function (_ref5) {
  var popoverUse = _ref5.popoverUse;
  return popoverUse.includes('tooltip') ? '3px' : null;
}, function (_ref6) {
  var width = _ref6.width;
  return (0, _Styles.toPx)(width);
}, function (_ref7) {
  var width = _ref7.width;
  return (0, _Styles.toPx)(width);
}, getBackgroundColor, getSideStyles, getEdgeStyles);

var UIPopoverArrow = (0, _memoWithDisplayName2.default)('UIPopoverArrow', function (_ref8) {
  var className = _ref8.className,
      width = _ref8.width,
      rest = _objectWithoutProperties(_ref8, ['className', 'width']);

  return width === 0 ? null : _react2.default.createElement(Arrow, _extends({}, rest, {
    className: (0, _classnames2.default)('uiPopoverArrow private-popover__arrow', className),
    width: width
  }));
});

if (process.env.NODE_ENV !== 'production') {
  UIPopoverArrow.propTypes = {
    color: _propTypes2.default.string,
    inset: _propTypes2.default.number.isRequired,
    placement: _propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    popoverUse: _propTypes2.default.oneOf(Object.keys(_Use.USE_CLASSES)),
    width: _propTypes2.default.number
  };
}

UIPopoverArrow.defaultProps = {
  inset: 0,
  placement: 'top',
  width: 20
};

UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};

exports.default = UIPopoverArrow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/UIPopoverArrow.js
// module id = 114
// module chunks = 177